<i18n src="./../../i18n/faq_page.json"></i18n>

<template>
    <div id="faq-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid" v-if="loaded">
            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;">FAQ</p>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">

                        <div class="container">
                            <div class="content-container p-3 pt-5">
                                <div class="row">
                                    <div class="col text-center">
                                        <h1 v-text="$t('title')"/>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col pr-lg-5 pl-lg-5 text-justify" v-html="$t('description', { phone: contactPhone })" />
                                </div>
                                <div class="row justify-content-center">
                                    <div class="lazy col-lg-4 mt-faq-container" v-for="item in content" :key="item.name" :item-data="item">
                                        <div class="row mt-5 mb-5">
                                            <div class="col-3 text-center pr-3 pl-2">
                                                <img :src="item.thumbnail" :alt="item.thumbnailAlt">
                                            </div>
                                            <div class="col-9 text-center my-auto ml-0 pl-0">
                                                <h4 class="mt-c-blue-regular text-uppercase" v-text="item.name"/>
                                            </div>
                                        </div>
                                        <div class="row justify-content-center" v-for="(faq, index) in item.faqs" :key="faq.question" :class="{'mt-4': index !== 0}">
                                            <div class="col-md-11 col">
                                                <div class="row">
                                                    <div class="col-1 m-0 p-0">
                                                        <img class="lazy" data-src="/assets/mt-faq-q-bar.png" alt="Q">
                                                    </div>
                                                    <div class="col-11 m-0 p-0 my-auto">
                                                        <router-link :to="{name: 'faqPage', params: {pageName: cleanPath(faq.url)}}">
                                                            <p class="m-0 p-0 mt-c-blue-regular" v-text="faq.question"/>
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import axios from "axios";
    import {Const} from "@/main";
    import $ from "jquery";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "FaqPage",
        components: {MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                contactPhone: Const.CONTACT_PHONE,
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted() {
            axios.get(`${Const.API_HOST}/${this.locale}/content/faq`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });

            $(document).scroll(function () {
                var $nav = $(".navbar-light");
                $nav.removeClass('initial');
                $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
        },
        methods: {
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            }
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }
</style>